// extracted by mini-css-extract-plugin
export var MuiSelectSelect = "DigitalWalkInModal-module--MuiSelect-select--be9d1";
export var closeButton = "DigitalWalkInModal-module--closeButton--9eac3";
export var container = "DigitalWalkInModal-module--container--6f510";
export var description = "DigitalWalkInModal-module--description--c79f4";
export var label = "DigitalWalkInModal-module--label--ccd69";
export var note = "DigitalWalkInModal-module--note--a716a";
export var root = "DigitalWalkInModal-module--root--22623";
export var select = "DigitalWalkInModal-module--select--ec214";
export var timePicker = "DigitalWalkInModal-module--timePicker--14820";
export var title = "DigitalWalkInModal-module--title--06a7b";